import { theme } from '@frontend/theme';
import { DentalInsuranceDetailsContainer } from '../dental-insurance-details-container';
import { AccordionInsuranceTables } from '../index';
import { PrintableFooter } from './PrintableFooter';
import { PrintableHeader } from './PrintableHeader';

type PrintableInsuranceReportProps = {
  isReportWriteback?: boolean;
};

export const PrintableInsuranceReport = ({ isReportWriteback = false }: PrintableInsuranceReportProps) => {
  return (
    <section css={{ background: theme.colors.neutral5, width: '100%' }}>
      <section
        css={{
          margin: theme.spacing(3),
          backgroundColor: theme.colors.white,
          borderRadius: theme.borderRadius.medium,
        }}
      >
        <PrintableHeader />
        <section>
          <div css={{ margin: theme.spacing(3), backgroundColor: theme.colors.white }}>
            <DentalInsuranceDetailsContainer isReportWriteback={isReportWriteback} isPrintReport />
            <AccordionInsuranceTables isPrintReport />
          </div>
        </section>

        <PrintableFooter />
      </section>
    </section>
  );
};
